import { render } from "./StartAuthorize.vue?vue&type=template&id=ee35e12e&scoped=true&ts=true"
import script from "./StartAuthorize.vue?vue&type=script&lang=ts"
export * from "./StartAuthorize.vue?vue&type=script&lang=ts"

import "./StartAuthorize.vue?vue&type=style&index=0&id=ee35e12e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee35e12e"]])

export default __exports__